module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.25f412a6.png";